export const UBI_PROGRAM = {
  TRUE_MOTION: 'UBI_DEVICE',
  AUTOMATIC: 'UBI_VEHICLE'
};
